import * as urls from '@client/routes';

export const conditionsAndPoliciesPath = `(${urls.userTermsPage}|${urls.privacyPolicyPage}|${urls.cookiesPage}|${urls.conditionsAndPoliciesMenu}|${urls.securityPage}|${urls.conditionsAndPoliciesOnboardingPage})`;
export { LazyLoadedConditionsAndPoliciesRoute } from './LazyLoadedConditionsAndPoliciesRoute';
